module.exports = __webpack_public_path__ + "media/img/home/animate/mobile/item3-335ed50d6053989adee12623613660fb.svg";